export const parseQuery = (queryString: string): Record<string, string> => {
  if (!queryString) return {}

  const isQueryPrefixed = queryString.startsWith("?")
  const queryWithoutPrefix = isQueryPrefixed ? queryString.slice(1) : queryString

  return queryWithoutPrefix.split("&").reduce((query: Record<string, string>, pair: string) => {
    const [key, value] = pair.split("=")
    if (key) query[decodeURIComponent(key)] = decodeURIComponent(value || "")

    return query
  }, {})
}
